import { c as _c } from "react/compiler-runtime";
import { Tooltip } from '@mui/material';
import type { InventoryResource } from '@repo/api-gw-sdk';
import { Tag } from '@/components/tag';
import { useRoles } from '@/contexts/useRoles';
import { SensitivityLevels } from '@/data/inventory/data';
import { AutoClassification } from './autoClassifcationButtons';
export const SensitivityLevelTag = t0 => {
  const $ = _c(5);
  const {
    level
  } = t0;
  const title = SensitivityLevels[level]?.title ?? level;
  const t1 = SensitivityLevels[level]?.description ?? title;
  let t2;
  if ($[0] !== title) {
    t2 = <Tag variant="primary" content={title} />;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t1 || $[3] !== t2) {
    t3 = <Tooltip title={t1}>{t2}</Tooltip>;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};
export function SensitivityAnnotationsViewer(t0) {
  const $ = _c(38);
  const {
    entity,
    setEditorOpen,
    restartDetection
  } = t0;
  const {
    isAuthorizedResource
  } = useRoles();
  const details = entity.classifications?.sensitivityLabelsDetails;
  const effectiveLevel = details?.sensitivityLevel ?? "";
  const effectiveLevelTitle = SensitivityLevels[effectiveLevel]?.title ?? effectiveLevel;
  if (details?.isOverridden) {
    let t1;
    if ($[0] !== restartDetection) {
      t1 = () => restartDetection();
      $[0] = restartDetection;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    let t2;
    let t3;
    if ($[2] !== setEditorOpen) {
      t2 = () => setEditorOpen();
      t3 = () => setEditorOpen();
      $[2] = setEditorOpen;
      $[3] = t2;
      $[4] = t3;
    } else {
      t2 = $[3];
      t3 = $[4];
    }
    let t4;
    if ($[5] !== entity || $[6] !== isAuthorizedResource) {
      t4 = isAuthorizedResource("update:sensitivity_annotations", entity);
      $[5] = entity;
      $[6] = isAuthorizedResource;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    const t5 = !t4;
    let t6;
    if ($[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t5) {
      t6 = <AutoClassification testId="sensitivity-annotations-auto-classification-buttons-override" textOn="" isAutoClassificationOn={false} restartDetectionClicked={t1} editOverridesClicked={t2} setEditorOpen={t3} disabled={t5} />;
      $[8] = t1;
      $[9] = t2;
      $[10] = t3;
      $[11] = t5;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    let t7;
    if ($[13] !== effectiveLevel) {
      t7 = <SensitivityLevelTag level={effectiveLevel} />;
      $[13] = effectiveLevel;
      $[14] = t7;
    } else {
      t7 = $[14];
    }
    let t8;
    if ($[15] !== t6 || $[16] !== t7) {
      t8 = <>{t6}{t7}</>;
      $[15] = t6;
      $[16] = t7;
      $[17] = t8;
    } else {
      t8 = $[17];
    }
    return t8;
  }
  const textOn = effectiveLevelTitle ? "This sensitivity level was detected:" : "No sensitivity level was detected";
  let t1;
  if ($[18] !== restartDetection) {
    t1 = () => restartDetection();
    $[18] = restartDetection;
    $[19] = t1;
  } else {
    t1 = $[19];
  }
  let t2;
  let t3;
  if ($[20] !== setEditorOpen) {
    t2 = () => setEditorOpen();
    t3 = () => setEditorOpen();
    $[20] = setEditorOpen;
    $[21] = t2;
    $[22] = t3;
  } else {
    t2 = $[21];
    t3 = $[22];
  }
  let t4;
  if ($[23] !== entity || $[24] !== isAuthorizedResource) {
    t4 = isAuthorizedResource("update:sensitivity_annotations", entity);
    $[23] = entity;
    $[24] = isAuthorizedResource;
    $[25] = t4;
  } else {
    t4 = $[25];
  }
  const t5 = !t4;
  let t6;
  if ($[26] !== t1 || $[27] !== t2 || $[28] !== t3 || $[29] !== t5 || $[30] !== textOn) {
    t6 = <AutoClassification testId="sensitivity-annotations-auto-classification-buttons-auto" textOn={textOn} isAutoClassificationOn={true} restartDetectionClicked={t1} editOverridesClicked={t2} setEditorOpen={t3} disabled={t5} />;
    $[26] = t1;
    $[27] = t2;
    $[28] = t3;
    $[29] = t5;
    $[30] = textOn;
    $[31] = t6;
  } else {
    t6 = $[31];
  }
  let t7;
  if ($[32] !== effectiveLevel || $[33] !== effectiveLevelTitle) {
    t7 = !!effectiveLevelTitle && <SensitivityLevelTag level={effectiveLevel} />;
    $[32] = effectiveLevel;
    $[33] = effectiveLevelTitle;
    $[34] = t7;
  } else {
    t7 = $[34];
  }
  let t8;
  if ($[35] !== t6 || $[36] !== t7) {
    t8 = <>{t6}{t7}</>;
    $[35] = t6;
    $[36] = t7;
    $[37] = t8;
  } else {
    t8 = $[37];
  }
  return t8;
}